export default {
  app: {
    name: "Real Time System",
    full: "Real Time System",
    minimized: "RTS"
  },
  welcome: "Welcome back, {user}!",
  login: "Sign In to your account",
  relogin: "Please re-login to your account again.",
  expired: "Session Expired!",
  denied: "Permission Denied!",
  success: "You have successfully completed!",
  search_by_id_name: "Search by ID or Name",
  search_by_id_providerid_url: "Search by ID, Provider ID or URL",
  search_by_id_host_port: "Search by ID, Host or Port",
  search_by_id: "Search by ID",
  change_user_status_confirm: "Are you sure you want to change the Account Status?",
  delete_confirm: "Are you sure you want to delete \"{name}\"",
  successful_change_password: "You have successfully change password.",
  change_disable_confirm: "Are you sure you want to change \"{name}\" to disable?",
  change_time_sync_confirm: "Are you sure you want to change \"{name}\" time sync?",
  select_option: "Select your option",
  search_by_league_name: "Search by League Name",
  no_data_available: "No Data Available",
  change_cmd_enabled_confirm: "Are you sure you want to change \"{name}\" cmd enabled?",
  change_affect_value_confirm: "Are you sure you want to change \"{name}\" affect value?",
  change_batch_affect_value_confirm: "Are you sure you want to change the affect value?",
  change_semi_auto_confirm: "Are you sure you want to change \"{name}\" semi auto?",
  change_ldiff_confirm: "Are you sure you want to change \"{name}\" ldiff?",
  change_batch_ldiff_confirm: "Are you sure you want to change the ldiff?",
  change_auto_open_confirm: "Are you sure you want to change \"{name}\" auto open?",
  add_match_confirm: "Are you sure you want to add new match?",
  map_league_confirm: "Are you sure you want to map these two leagues?",
  unmap_league_confirm: "Are you sure you want to unmap these two leagues?",
  map_team_confirm: "Are you sure you want to map these two teams?",
  unmap_team_confirm: "Are you sure you want to unmap these two teams?",
  map_match_confirm: "Are you sure you want to map these two matches?",
  swap_map_match_confirm: "This action cannot be undone. Are you sure you want to swap map these two matches?",
  unmap_match_confirm: "Are you sure you want to unmap this match?",
  remap_match_confirm: "Are you sure you want to remap this match?",
  remap_league_confirm: "Are you sure you want to remap this league?",
  remap_team_confirm: "Are you sure you want to remap this team?",
  change_prefer_id_confirm: "Are you sure you want to change \"{name}\" prefer id?",
  add_special_match_confirm: "Are you sure you want to add new special match?",
  swap_remap_match_confirm: "This action cannot be undone. Are you sure you want to swap remap these two matches?",
  purge_match_confirm: "This action cannot be undone. Are you sure you want to purge this match?",
  purge_league_confirm: "This action cannot be undone. Are you sure you want to purge this league?",
  purge_team_confirm: "This action cannot be undone. Are you sure you want to purge this team?",
  unlink_parent_league_confirm: "This action cannot be undone. Are you sure you want to unlink the parent league?",
  clear_match_rs_confirm: "This action cannot be undone. Are you sure you want to clear match's running score?",
  clear_match_rt_confirm: "This action cannot be undone. Are you sure you want to clear match's running time?",
  clear_match_rs_rt_all_confirm: "This action cannot be undone. Are you sure you want to clear today match's running score and running time?",
  update_rsrt_control_confirm: "Are you sure you want to change \"{provider}\" \"{sport}\" running score and running time control?",
  clear_match_rc_confirm: "This action cannot be undone. Are you sure you want to clear match's red card?",
  purge_sbo_league_confirm: "This action cannot be undone. Are you sure you want to purge this SBO league?",
  purge_sbo_team_confirm: "This action cannot be undone. Are you sure you want to purge this SBO team?",
  vip_bot_login_confirm: "Are you sure you want to vip \"{name}\"?",
  delete_disabled_login_confirm: "This action cannot be undone. Are you sure you want to delete all disabled login?",
  switch_provider_confirm: "Are you sure you want to switch all matches from \"{from}\" to \"{to}\"?",
  purge_cmd_sbo_mapping_confirm: "This action cannot be undone. Are you sure you want to purge this cmd/sbo mapping?",
  change_login_id_confirm: "Are you sure you want to change \"{name}\" login id?",
  purge_ibc_ibt_mapping_confirm: "This action cannot be undone. Are you sure you want to purge this ibc/ibt mapping?",
  affect_value_remark_1: "1) Set 0.00 for 100% side to IBC and set 1.00 for 100% side to SBO.",
  affect_value_remark_2: "2) Set 0.10-0.90 for taking both side. If both side have different margin, RTS will follow the lower margin odds. If both side have same margin, RTS will re-calculate the odds.",

  // OTP 2FA Messages
  other_authenticator_apps_supported: "Other two-factor authenticator applications such as Sophos, Microsoft Authenticator etc. are also supported",
  date_time_automatic_required: "The Date & Time settings on your device must be set to Automatic.",
  get_otp_2fa_qr_code_failed: "Failed to get OTP 2FA QR code. Please try again.",
  enter_secret_manually: "Enter this secret manually in your authenticator app",
  otp_setup_failed: "Failed to setup OTP. Please try again.",
  otp_verification_failed: "Invalid verification code. Please try again.",
  otp_2fa_bound: "Google Authenticator has been successfully bound to your account.",
  invalid_code: "Invalid code. Please check the code and try again.",
  code_required: "Please enter the 6-digit code from your authenticator app.",
  otp_unbind_success: "OTP has been unbound successfully.",
  otp_unbind_failed: "Failed to unbind OTP 2FA. Please try again.",


};
